<template>
  <div class="footer">
    <div class="footerTopColour">
      <b-container>
        <h2 class="ocsSponTitle">Sponsors & Partners</h2>
        <b-row :class="logoRow" class="sponsorsBackGround">
          <b-col v-for="(logos, index) in footerData" :key="'footer' + index" class='mobileCol'>
            <a :href="logos.link" target="_blank" rel="noopener">
              <b-img :class="{logoImg, new: logos.sponsor_image == 'https://ocs-sport.ams3.digitaloceanspaces.com/cpt/2020/07/Focus-Foundation-Vector-Logo.png' } " :src="logos.sponsor_image" />
            </a>
          </b-col>
        </b-row>
      </b-container>


    </div>
    <div class="footerBottomColour">
      <b-container>
        <b-row class="ocs showDesk spaceDesk">
          <b-col>
            <h2 class="footerHeading">Event, Entries & Tournament Invite Enquiries</h2>
            <p class='tmarkMob'>
              contact@clutchprotour.co.uk
              <!-- callum@clutchprotour.co.uk -->
            </p>
          </b-col>
          <b-col>
            <h2 class="footerHeading">Partnership Options</h2>
            <!-- <div class="space"></div> -->
            <p class='tmarkMob'>
              partnership@clutchprotour.co.uk
            </p>
          </b-col>
          <b-col>
              <div class="socialBlock">                            
                  <b-link href="https://www.instagram.com/clutchprotour/?hl=en" target="_blank">
                      <div class="socialImage rightMarg instaBk"></div>
                  </b-link>
                  <b-link href="https://www.facebook.com/clutchprogolftour" target="_blank">
                      <div class="socialImage rightMarg faceBk"></div>
                  </b-link>
                  <!-- <b-link href="https://x.com/clutchprotour" target="_blank">
                      <div class="socialImage rightMarg ticBk"></div>
                  </b-link> -->
                  <b-link href="https://www.tiktok.com/@clutchprotour" target="_blank">
                      <div class="socialImage rightMarg ticBk"></div>
                  </b-link>
                  <b-link href="https://www.youtube.com/channel/UCS34dfBB8jyD98wSFgrwBoA" target="_blank">
                      <div class="socialImage rightMarg youBk"></div>
                  </b-link>
              </div>
          </b-col>
          <b-col>
              <div class="logoCen">
                <img class="LogoOCS" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Sport_white.png">
                <p>Powering Websites,<br> Data, Apps & Systems</p>
              </div>
          </b-col>
        </b-row>

        <b-row class="ocs showMob">
          <!-- <b-col lg="6" class="firstCol">
            <h2 class="footerHeading">Get In Touch</h2>
            <p class='tmarkMob'>
              Tom Hayward - CEO <br>
              07766147753 <br>
              tomhayward@clutchprotour.co.uk 
              <br><br>
              Lily Ross - CFO<br>
              07868607172<br>
              lilyross@clutchprotour.co.uk
            </p>
          </b-col> -->
          <b-col lg="12" class="secondCol">
            <h2 class="footerHeading">Event, Entries & Tournament Invite Enquiries</h2>
            <p class='tmarkMob'>
              contact@clutchprotour.co.uk<br> 
            </p>
            <div class="space"></div>
            <h2 class="footerHeading">Partnership Options</h2>
            <p class='tmarkMob'>
              Partnership@clutchprotour.co.uk
            </p>
          </b-col>
          <b-col lg="12">
              <div class="logoCen Mob">
                <img class="LogoOCS" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2023/05/OCS-Sport_white.png">
                <p>Powering Websites,<br> Data, Apps & Systems</p>
              </div>
          </b-col>
        </b-row>
        <!-- <b-row class="showMob bottonSub">
          <b-col lg="12">
            <b-link :to="'/privacy-policy'" class="footerLinks">Privacy Policy</b-link>
          </b-col>
        </b-row> -->
      </b-container>
    </div>
  </div>
</template>

<script>
import * as CryptoJS from 'crypto-js';
import apiCall from "@/services/api.js";
import axios from 'axios';
export default {
  name: "Footer",
  props:['config'],
  data() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      footerData: [],
      logoImg: "logoImg",
      ocsLogo: "ocsLogo",
      logoRow: "logoRow",
      logoRowMobile: "logoRowMobile", 
      activeTrue: false,
      cryptoAES: CryptoJSAesJson,
      email: '',
      status: '',
      message: ''
    };
  },
  methods: {
    hashString(input) {
      return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
    },
    marketingPost: function() {
        // let emailHash = this.hashString(this.email)
        let post_string = "email=" + encodeURIComponent(btoa(this.email))
        console.log("post_string")
        console.log(post_string)
        axios
            .post(
                'https://ocs-cpt.com/apps/marketing.php?random=123412&' + "tour=" + 'cpt' + "&action=register&access_key=" + 'F1D9A2B243779F6CAFD5E5274CC55E8606A8CCC239A5CF2E9FDA5C27FF303EF0' + "&mc_host=" + 'https://ocs-cpt.com&from_tms=N&',
                post_string, {
                    headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            )
        .then((response) => {
            console.log(response)
            this.status = response.data.status;
            this.message = response.data.message;
        })  
    }
  },
  created() {
    const json = "wp/v2/sponsors?randomadd=" +
            new Date().getTime();
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.footerData = data[0].acf.sponsors;
        console.log("this.footerData");
        console.log(this.footerData);
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
img.logoImg.new {
  height: auto;
}
.logoCen.Mob {
  text-align: left;
  font-size: 9pt;
  position: relative;
  top: -15px;
}
.logoCen {
  text-align: right;
  font-size: 9pt;
  position: relative;
  top: -15px;
}
.space {
  margin-bottom: 35px;
}
a.footerLinks {
  color: #fff !important;
}
a.footerLinks:hover {
  color: #081C3F !important;
  text-decoration: none;
}
button.signUP {
  background-color: #081C3F;
  border: 1px solid #081C3F;
  color: #fff;
}
button.signUP:hover {
  background-color: #ffffff;
  border: 1px solid #081C3F;
  color: #000;
}
.inputFieldMob {
  width: 100%;
  margin-bottom: 30px;
}
.secondCol.col-lg-6 {
  width: 50%;
}
.firstCol.col-lg-6 {
  width: 50%;
  padding-left: 0;
}
.rightMarg {
  margin-right: 20px;
}
.socialBlock {
  display: inline-flex;
  float: right;
}
.instaBk {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Instagram-1.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
}
.instaBk:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Instagram_Blue.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
}
.faceBk {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Facebook-1-1.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.faceBk:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/Facebook_BLUE.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.ticBk {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/TikTok.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
}
.ticBk:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/TikTok_Blue.png');
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
}
.youBk {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/YouTube.png');
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 25px !important;
}
.youBk:hover {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/02/YouTube_Blue.png');
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 25px !important;
}
.row.ocs.showMob {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
}
.row.ocs.showDesk.spaceDesk {
  padding-top: 7em;
}
img.socialImage.rightMarg {
  margin-right: 20px;
}
.socialImage {
  /* width: 65px; */
  width: 20px;
  margin-top: 5px;
}
.footerSectionOne {
  font-size: 30px;
}
.footerHeading {
  color: #00FFFE;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 24px;
  padding-bottom: 30px;
}
.row.sponsorsBackGround.logoNoPad.logoRow {
    padding-top: 0;
    margin-top: -50px;
}
h2.ocsSponTitle.cosponsors {
  padding-top: 0px;
}
.standardText-size {
  font-size: 16px;
  padding-left: 40px;
}
.footerTopColour {
  background-color: #fff;
  padding-bottom: 80px;
}
.sponsorsBackGround {
  background-color: #fff;
}
.ocsSponTitle {
  background-color: #fff;
  color: #081C3F;
  font-size: 36px;
  text-align: center;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  margin-bottom: 0;
  padding-top: 90px;
  padding-bottom: 40px;
}
.footer {
  /* background-color: #081C3F;  */
  color: white;
  /* padding-top: 2%; */
  /* padding-left: 2%; */
}

.logoRowMobile {
  display: none;
}

.logoImg {
  width: 250px;
  mix-blend-mode: multiply;
  height: 250px;
}

.ocsLogo {
  width: 256px;
  padding-bottom: 40px;
}

.logoRow {
  /* padding-top: 4%; */
  /* padding-top: 2%;
  padding-bottom: 4%; */
  text-align: center;
  margin-right: 0;
}
.ocs {
  margin-right: 0;
  background-color: #081C3F; 
}
.footerBottomColour {
  background-color: #081C3F;
  /* height: 568px; */
  height: 368px;
}
.footerBottomColourBTN {
  background-color: #081C3F;
  /* height: 568px; */
}
.tmark{
  margin-top: 40px;
  font-size: 20px;
  vertical-align: middle;
  font-weight: 200;
}
.tmarkMob{
  font-size: 20px;
  font-weight: 200;
}
::v-deep .nav-link {
  color: white !important;
  padding: 0.7rem 1rem;
  font-size: 14px;
}

::v-deep .navbar {
  padding-bottom: 0;
}

::v-deep .navbar-toggler {
  border: 0px;
}

::v-deep .nav-link:hover {
  color: #081C3F !important;
  background-color: white;
}

::v-deep .dropdown-item {
  color: white !important;
  background-color: #081C3F;
}

::v-deep .dropdown-menu {
  color: white !important;
  background-color: #081C3F;
}

::v-deep .dropdown-item:hover {
  color: #081C3F !important;
  background-color: white;
}

@media only screen and (max-width: 1201px) {
  .logoImg {
      /* width: 100%; */
      /* width: 150px; */
      mix-blend-mode: multiply;
  }
}
@media only screen and (min-width: 1025px) {
  .showMob {
    display: none;
  }
}
@media only screen and (max-width: 1024px) {
  .row.showMob.bottonSub {
    text-align: left;
    padding-bottom: 20px;
  }
  .showDesk {
    display: none;
  }
  .footerBottomColour {
    background-color: #081C3F;
    height: auto;
  }
  .footerSectionOne {
    font-size: 14px;
  }
  .tmarkMob {
    font-size: 14px;
    font-weight: 200;
  }
  .footerHeading {
    color: #00FFFE;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    font-size: 20px;
    padding-bottom: 25px;
  }
  .socialImage {
    width: 30px;
    margin-top: 10px;
  }
  .row.ocs.showMob {
    text-align: left;
    padding-top: 60px;
    padding-bottom: 20px;
  }
}
@media only screen and (max-width: 990px) {
  .ocsSponTitle {
    /* background-color: #F8F8F8; */
    color: #081C3F;
    font-size: 26px!important;
    text-align: left!important;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    margin-bottom: 0;
    padding-top: 25px;
    padding-bottom: 25px;
  }
}
@media only screen and (max-width: 768px) {
  .mobileCol {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .ocsLogo {
    width: 30%;
  }
  .row.ocs.showMob {
    text-align: left;
    margin: auto;
  }
  .standardText-size {
    font-size: 16px;
    padding-left: 0px;
  }
  .ocsLogo {
    width: 30% !important;
    /* margin-top: 15px!important; */
    margin-top: -7px!important;
  }
  .ocsSponTitle {
    /* background-color: #F8F8F8; */
    color: #081C3F;
    font-size: 40px;
    text-align: center;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    margin-bottom: 0;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .footerTopColour {
    /* display: none; */
    padding-bottom: 25px;
  }
}
@media only screen and (max-width: 768px) {
.logoImg[data-v-6c4d8baa] {
    width: 100%;
    mix-blend-mode: multiply;
    height: auto;
}
}
@media only screen and (max-width: 510px) {
  .footerTopColour {
    /* display: none; */
  }
}

@media only screen and (max-width: 480px) {
  .logoImg {
    width: 100%;
    height: auto;
  }
  ::v-deep .ocsLogo {
    width: 50%!important;
    margin-top: 40px;
  }
  .logoRow {
    /* display: none; */
  }
  .logoRowMobile {
    display: flex;
    padding-top: 4%;
    padding-bottom: 4%;
    text-align: center;
    margin-left: 0;
    margin-right: 0;
  }
  .ocs {
    margin-right: 0;
    margin-left: 0;
  }
  #nav{
    display: none;
  }
  .ocsLogo {
  width: 50%;
  }
}
</style>
